import { create } from "zustand";
import { persist } from "zustand/middleware";

export type MagicMomentDayOverride = "day1" | "day2" | null;

interface DevOverridesStore {
  magicMomentDay: MagicMomentDayOverride;
  forceDay2Modal: boolean;
  setMagicMomentDay: (value: MagicMomentDayOverride) => void;
  setForceDay2Modal: (value: boolean) => void;
  reset: () => void;
}

export const useDevOverridesStore = create(
  persist<DevOverridesStore>(
    (set) => ({
      magicMomentDay: null,
      forceDay2Modal: false,
      setMagicMomentDay: (value) => set({ magicMomentDay: value }),
      setForceDay2Modal: (value) => set({ forceDay2Modal: value }),
      reset: () => set({ magicMomentDay: null, forceDay2Modal: false }),
    }),
    {
      name: "dev-overrides",
    },
  ),
);
